import { SingleSelectField, TextField } from "components/RenderInput"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field, FieldArray } from "redux-form"
import ReactDragListView from "react-drag-listview/lib/ReactDragListView"

export const renderAnswersForm = ({
  fields,
  meta: { error, submitFailed },
  handleFieldFocus,
  hasReplies,
  updateCorrectAnswer,
}) => (
  <>
    {submitFailed && error && <span className={"input-error"}>{error}</span>}
    {fields.map((answer, index) => (
      <Row key={index} className="my-2 ms-1">
        <Col className="my-1">
          <Field
            name={`${answer}.answer`}
            component={TextField}
            placeholder={`Answer ${index + 1}`}
            style={{ display: "inline" }}
            onFocus={handleFieldFocus}
          />
        </Col>
        <Col xs={1} className="d-flex justify-content-end mt-2">
          {fields.length > 2 && (
            <i
              className="bx bx-sm bx-x"
              style={{
                paddingLeft: "5px",
                cursor: "pointer",
              }}
              onClick={
                hasReplies
                  ? () => {}
                  : () => {
                      const answer = fields.get(index)
                      if (answer?.right_answer) {
                        updateCorrectAnswer()
                      }
                      fields.remove(index)
                    }
              }
            />
          )}
        </Col>
      </Row>
    ))}
    {fields.length < 5 && (
      <Row>
        <Col>
          <p
            style={{ cursor: "pointer" }}
            onClick={
              hasReplies
                ? () => {}
                : () => fields.push({ id: null, answer: "" })
            }
          >
            + More Answers
          </p>
        </Col>
      </Row>
    )}
  </>
)

export const renderQuestionsForm = ({
  fields,
  hasReplies,
  handleFieldFocus,
}) => {
  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      fields.swap(fromIndex, toIndex)
    },
    nodeSelector: "div.card",
    handleSelector: "div.card",
    lineClassName: "dragDropLine",
  }

  const updateCorrectAnswer = questionIndex => {
    const questionField = fields.get(questionIndex)
    if (questionField) {
      fields.splice(questionIndex, 1, {
        ...questionField,
        correctAnswer: null,
      })
    }
  }

  return (
    <ReactDragListView {...dragProps}>
      {fields.map((question, index) => {
        const formValues = fields.get(index)
        return (
          <Card style={{ border: "1px solid black" }} key={index}>
            <CardHeader className="h5 bg-transparent border-bottom ">
              <Row>
                {fields.length > 1 && (
                  <Col xl={1}>
                    <i
                      className="bx bx-sm bx-menu"
                      style={{
                        cursor: "pointer",
                      }}
                    />
                  </Col>
                )}
                <Col xl={10} style={{ display: "inline" }}>
                  <p
                    style={{ display: "inline", verticalAlign: "text-bottom" }}
                  >
                    Trivia Question #{index + 1}:
                  </p>
                </Col>
                {fields.length > 1 && (
                  <Col xl={1} style={{ display: "inline" }}>
                    <i
                      className="bx bx-sm bx-x"
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={
                        hasReplies
                          ? () => {}
                          : () => {
                              fields.remove(index)
                            }
                      }
                    />
                  </Col>
                )}
              </Row>
            </CardHeader>
            <CardBody>
              <Row>
                <Col>
                  <Field
                    name={`${question}.question`}
                    component={TextField}
                    onFocus={handleFieldFocus}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <FieldArray
                    name={`${question}.answers`}
                    component={renderAnswersForm}
                    handleFieldFocus={handleFieldFocus}
                    hasReplies={hasReplies}
                    updateCorrectAnswer={() => updateCorrectAnswer(index)}
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col xs={12}>Select an answer to be the correct choice:</Col>
                <Col xs={12}>
                  <Field
                    name={`${question}.correctAnswer`}
                    fullWidth={true}
                    component={SingleSelectField}
                    placeholder="Select answer"
                    options={formValues.answers
                      .filter(answer => answer.answer && answer.answer.trim())
                      .map((answer, index) => ({
                        value: answer.answer,
                        label: answer.answer,
                      }))}
                    onFocus={handleFieldFocus}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        )
      })}
    </ReactDragListView>
  )
}
